import {useState} from 'react'
import {Content} from '../../../_metronic/layout/components/content'
import {KTIcon} from '../../../_metronic/helpers'
import DLRManagementForm from './modal/DLRManagementForm'
import DLRListTable from './DLRListTable'
import {IDLRList} from './_model'

const DLRManagement = () => {
  const [searchTerm, setSearchTerm] = useState('')
  const [selectedDlr, setSelectedDlr] = useState<IDLRList | undefined>(undefined)

  const onSelectDlr = (dlr: IDLRList) => {
    setSelectedDlr(dlr)
  }

  return (
    <Content>
      <div className='d-flex justify-content-between align-items-center mb-3 gap-4 flex-wrap'>
        <div className='d-flex align-items-center position-relative my-1 w-500px'>
          <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
          <input
            type='text'
            className='form-control form-control-solid ps-16 rounded-pill py-3 bg-transparent border border-gray-700'
            placeholder='Search'
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <div>
          <button
            type='button'
            className='btn btn-primary'
            data-bs-toggle='modal'
            data-bs-target='#kt_modal_1'
          >
            <KTIcon iconName='plus' className='fs-2' />
            Configure DLR
          </button>
        </div>
      </div>

      <DLRListTable searchTerm={searchTerm} onSelectDlr={onSelectDlr} />

      <DLRManagementForm selectedDlr={selectedDlr} />
    </Content>
  )
}

export default DLRManagement
